/**
 * Sheet utility – handles open/close animation for bottom-sheet (mobile)
 * and centred popup (desktop).
 */
export class Sheet {
    protected container: HTMLElement;
    protected overlay: HTMLElement;
    protected panel: HTMLElement;

    constructor(containerId: string) {
        this.container = document.getElementById(containerId) as HTMLElement;
        this.overlay   = this.container?.querySelector('[data-dismiss-modal]') as HTMLElement;
        this.panel     = this.container?.querySelector('[id$="-panel"]') as HTMLElement;

        this.overlay?.addEventListener('click', () => this.close());
    }

    protected isMobile(): boolean {
        return window.innerWidth < 768;
    }

    open(): void {
        if (!this.container) return;
        this.container.classList.remove('hidden');
        document.body.style.overflow = 'hidden';

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.overlay.classList.add('opacity-100');
                if (this.isMobile()) {
                    this.panel.classList.remove('translate-y-full');
                } else {
                    this.panel.classList.remove('md:opacity-0', 'md:scale-95');
                }
            });
        });
    }

    close(): void {
        if (!this.container) return;
        this.overlay.classList.remove('opacity-100');
        if (this.isMobile()) {
            this.panel.classList.add('translate-y-full');
        } else {
            this.panel.classList.add('md:opacity-0', 'md:scale-95');
        }
        setTimeout(() => {
            this.container.classList.add('hidden');
            document.body.style.overflow = '';
        }, 300);
    }
}
